export const asterisk = '*';
export const comma = ',';
export const dash = '-';
export const dot = '.';
export const empty = '';
export const newLine = '\n';
export const semicolon = ';';
export const slash = '/';
export const space = ' ';
export const pipe = '|';
export const underscore = '_';
